(() => {
  function initialize() {
    document.querySelectorAll('[data-cyrai-mobile-autoplay]').forEach((list) => {
      if (list.dataset.cyraiAutoplayInitialized === 'true') return;
      const scroller = list.querySelector('.product-list__inner--scroller');
      if (!scroller) return;
      list.dataset.cyraiAutoplayInitialized = 'true';
      let pauseUntil = 0;
      ['pointerdown', 'touchstart', 'keydown'].forEach((type) => {
        list.addEventListener(type, () => { pauseUntil = Date.now() + 10000; }, { passive: true });
      });
      const timer = window.setInterval(() => {
        if (!list.isConnected) { window.clearInterval(timer); return; }
        if (!window.matchMedia('(max-width: 740px)').matches || window.matchMedia('(prefers-reduced-motion: reduce)').matches || document.hidden || list.hidden || Date.now() < pauseUntil || list.contains(document.activeElement)) return;
        const bounds = list.getBoundingClientRect();
        if (bounds.bottom < 0 || bounds.top > window.innerHeight) return;
        const card = scroller.firstElementChild;
        if (!card || scroller.scrollWidth <= scroller.clientWidth) return;
        const gap = parseFloat(getComputedStyle(scroller).columnGap) || 24;
        const end = scroller.scrollWidth - scroller.clientWidth;
        const next = scroller.scrollLeft >= end - 4 ? 0 : Math.min(end, scroller.scrollLeft + card.getBoundingClientRect().width + gap);
        scroller.scrollTo({ left: next, behavior: 'smooth' });
      }, 4000);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
